import { createFileRoute, redirect } from '@tanstack/react-router';

// The Settings IA reorg moved every card this page held into the /app/settings
// hub: campaign preferences (timezone, voice, canvass questions, voter import) →
// Campaign preferences, subscription → Billing, campaign identity / committee
// profile → Campaign & Committee, and the platform-ops cards → the hub's Admin
// section. The route is retained as a redirect stub (no component) so existing
// bookmarks and login-redirect deep-links resolve to /app/settings instead of
// 404ing. The incoming search is carried through so the ?campaignId=<guid>
// email deep-link still auto-switches the campaign once the /app layout mounts.
export const Route = createFileRoute('/admin/campaign-settings')({
  beforeLoad: ({ search }: { search: Record<string, unknown> }) => {
    throw redirect({ to: '/app/settings', search });
  },
});
